import React, { useEffect } from 'react'
import { Button } from '../../../../../../components/Button'
import { api } from '../../../../../../services/api'
import { useForm } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import { z } from 'zod'
import { useMutation } from 'react-query'
import { Flex, IconButton, Text, useToast } from '@chakra-ui/react'
import { DragAndDrop } from '../../../../../../components/DragAndDrop'
import { FaEye } from 'react-icons/fa'

const schema = z.object({
  numero_nota: z.string().nonempty('O número da nota é obrigatório.'),
  sequencia: z.string().nonempty('A sequência é obrigatória.'),
  codigo_produto: z.string().nonempty('O código do produto é obrigatório.'),
  arquivo: z.instanceof(File).refine((file) => !!file, {
    message: 'O arquivo é obrigatório.',
  }),
})

async function onUpdateArquivo(data) {
  const res = await api.post('/site/v2/orcamento-crm/envia-imagem-comprovacao-negociacao', data)

  return res.data
}

export const UploadArquivo = ({ item }) => {
  const {
    control,
    handleSubmit,
    watch,
    formState: { isValid, errors },
    setValue,
    register,
  } = useForm({
    resolver: zodResolver(schema),
  })

  const arquivo = watch('arquivo')

  const toast = useToast({
    position: 'top-right',
  })

  const { mutateAsync, isLoading, data } = useMutation({
    mutationFn: onUpdateArquivo,
    onSuccess: () => {
      toast({
        status: 'success',
        title: 'Sucesso!',
        description: 'Arquivo enviado com Sucesso!',
      })
    },
  })

  async function onSubmit(data) {
    const formData = new FormData()
    formData.append('numero_nota', data.numero_nota)
    formData.append('sequencia', data.sequencia)
    formData.append('codigo_produto', data.codigo_produto)
    formData.append('arquivo', data.arquivo)

    await mutateAsync(formData)
  }

  function visualizarArquivo() {
    if (!arquivo) {
      toast({
        status: 'warning',
        title: 'Aviso',
        description: 'Nenhum arquivo selecionado para visualização.',
      })
      return
    }

    const file = arquivo

    if (!(file instanceof File)) {
      toast({
        status: 'error',
        title: 'Erro',
        description: 'Arquivo inválido para visualização.',
      })
      return
    }

    const fileURL = URL.createObjectURL(file)
    window.open(fileURL, '_blank')
  }

  useEffect(() => {
    setValue('numero_nota', item.numero_nota)
    setValue('sequencia', item.sequencia)
    setValue('codigo_produto', item.codigo_produto)
  }, [setValue, item])

  return (
    <Flex flexDir="column" gap={2} mt={5}>
      <Text>Enviar Imagem</Text>
      <DragAndDrop control={control} name="arquivo" />
      <Flex gap={2} w="100%" alignItems="center">
        <input hidden {...register('sequencia')} />
        <input hidden {...register('numero_nota')} />
        <input hidden {...register('codigo_produto')} />
        <Button w="100%" isLoading={isLoading} onClick={handleSubmit(onSubmit)}>
          Enviar Arquivo
        </Button>
        <IconButton aria-label="Visualizar Arquivo" onClick={visualizarArquivo}>
          <FaEye />
        </IconButton>
      </Flex>
    </Flex>
  )
}
